
import { useRef, useEffect } from "react";
import { ChatMessage, Channel } from "@/lib/types";
import { MessageItem } from "./MessageItem";
import { MessageSquare } from "lucide-react";

type MessageListProps = {
  messages: ChatMessage[];
  channel: Channel;
};

export const MessageList = ({ messages, channel }: MessageListProps) => {
  const messageEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Auto-scroll to newest messages
    messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div 
      className={`flex-grow overflow-y-auto p-4 space-y-4 ${channel.isTemporary ? 'bg-orange-50 dark:bg-orange-950/20' : ''}`}
    >
      {messages.length === 0 ? (
        <div className="text-center text-muted-foreground py-10">
          <MessageSquare className="h-10 w-10 mx-auto mb-2 opacity-20" />
          <p>No messages yet. Start the conversation!</p>
        </div>
      ) : (
        messages.map((message) => (
          <MessageItem key={message.id} message={message} />
        ))
      )}
      <div ref={messageEndRef} />
    </div>
  );
};
